import React from 'react';
import { createUseStyles } from 'react-jss';
import SectionHeading from '@src/components/SectionHeading';

const useStyles = createUseStyles({
  root: {
    lineHeight: '24px',
    '& div': {
      marginBottom: '1em',
    },
  },
});

const SectionSubHeading = ({ children }: { children: React.ReactNode }) => {
  return (
    <h5 style={{ fontSize: '16px', fontWeight: 'bold', display: 'inline' }}>
      {children}
    </h5>
  );
};

export default function BuilderTermsOfService() {
  const styles = useStyles();

  return (
    <div className={styles.root}>
      <SectionHeading isFirst style={{ textAlign: 'center' }}>
        <div>ATeams - Builder Development Services Terms and Conditions</div>
        <div>DEVELOPMENT SERVICES TERMS AND CONDITIONS</div>
      </SectionHeading>
      Please read these ATeams - Builder Development Services Terms and
      Conditions (the "Terms and Conditions") carefully as they govern the use
      and performance of any Development Services - and the corresponding
      Platform Services - as identified in any Service Order that incorporates
      these Terms by reference (collectively, the Terms and Conditions and any
      Service Order, the "Agreement"). The Agreement is between 2022 Services
      LLC ("ATeams") and the person or entity identified in the Service Order as
      Builder. In the event of a conflict between this Agreement and any Service
      Order, the provisions of this Agreement will govern and control with the
      understanding that a conflicting provision in a Service Order will take
      precedence over the Agreement if the Service Order expressly states the
      provision in the Terms and Conditions that is intended to be superseded by
      the Service Order. In consideration of the mutual promises contained
      herein, the parties hereby agree to the following:
      <SectionHeading>1. DEFINITIONS</SectionHeading>
      In addition to terms defined in the body of this Agreement, as used in
      this Agreement:
      <div>
        <SectionSubHeading>1.1. Confidential Information</SectionSubHeading>
        means any and all information disclosed by or on behalf of either ATeams
        or Builder that is labeled or identified as "confidential" or
        "proprietary" or that a would reasonably be expected to be understood as
        confidential or proprietary given the nature of the information or the
        circumstances surrounding its disclosure.
      </div>
      <div>
        <SectionSubHeading>1.2. Development Services</SectionSubHeading>
        means the services to be performed or actually performed by Builder
        under this Agreement, including those that are identified in an
        applicable Service Order.
      </div>
      <div>
        <SectionSubHeading>1.3. Intellectual Property</SectionSubHeading>
        means all algorithms, application programming interfaces (APIs), circuit
        designs and assemblies, concepts, Confidential Information, data,
        databases and data collections, designs, diagrams, documentation,
        drawings, flow charts, formulae, ideas and inventions, know-how,
        materials, marketing and development plans, marks, methods, models, net
        lists, network configurations and architectures, procedures, processes,
        protocols, schematics, software code, specifications, subroutines,
        techniques, test vectors, tools, uniform resource identifiers, user
        interfaces, web sites, works of authorship, and other forms of
        technology.
      </div>
      <div>
        <SectionSubHeading>1.4. Intellectual Property Rights</SectionSubHeading>
        means all past, present, and future rights of the following types, which
        may exist or be created under the laws of any jurisdiction in the world:
        (a) rights associated with works of authorship, including exclusive
        exploitation rights, copyrights, moral rights, and mask work rights; (b)
        trademark and trade name rights and similar rights; (c) trade secret
        rights; (d) patent and industrial property rights; (e) other proprietary
        rights in Intellectual Property of every kind and nature and (f) rights
        in or relating to registrations, renewals, extensions, combinations,
        divisions, and reissues of, and applications for, any of the rights
        referred to in clauses (a) through (e) of this sentence.
      </div>
      <SectionHeading>2. PLATFORM SERVICES</SectionHeading>
      <div>
        <SectionSubHeading>2.1. Generally</SectionSubHeading>
        ATeams makes the Platform Services available to Builder for the purpose
        of seeking matches between Builder and companies seeking assistance with
        technology project needs. Subject to the terms and conditions set forth
        in this Agreement, ATeams will use commercially reasonable efforts to
        provide Builder with access to the Platform Services.
      </div>
      <div>
        <SectionSubHeading>2.2. Registration</SectionSubHeading>
        Use of and access to the Platform Services may require registration of
        an account ("Account"). In registering an Account, Builder agrees to (a)
        provide true, accurate, current and complete information ("Registration
        Data"), and (b) maintain and promptly update the Registration Data to
        keep it true, accurate, current and complete.
      </div>
      <div>
        Builder agrees not to provide any false or misleading information about
        Builder's identity, location, or business and to correct any such
        information that is or becomes false or misleading. Builder is
        responsible for all activities that occur under Builder's Account and
        may not share Account or password information with anyone (other than
        Permitted Users (as defined below)). Builder agrees to notify ATeams
        immediately of any unauthorized use of Builder's password or any other
        breach of security. If Builder provides any information that is untrue,
        inaccurate, not current or incomplete, or ATeams has reasonable grounds
        to suspect that any information Builder provides is untrue, inaccurate,
        not current or incomplete, ATeams has the right to suspend or terminate
        Builder's Account and refuse any and all current or future use of the
        Platform Services (or any portion thereof). Builder may not have more
        than one Account at any given time. Consistent with the provisions in
        Section 16.2, Builder may not create an Account or use the Platform
        Services if Builder has been previously removed by ATeams or previously
        banned from the Platform Services. ATeams reserves the right to decline
        a registration to join ATeams or to add an Account, for any lawful
        reason, including supply and demand, cost to maintain data, or other
        business considerations.
      </div>
      <div>
        <SectionSubHeading>2.3. Account Verification</SectionSubHeading>
        When Builder registers for an Account and from time to time thereafter,
        Builder's Account will be subject to verification, including, but not
        limited to, validation against third-party databases or verification of
        one or more official government or legal documents that confirm a
        Permitted User's (as defined below) identity, location, and ability to
        act on behalf of Builder's business. Builder authorizes ATeams, directly
        or through third parties, to make any inquiries necessary to validate a
        User's identity, location, and ownership of email address or financial
        accounts, subject to applicable law. When requested, Builder must timely
        provide ATeams with complete information about Builder and Builder's
        business, which includes, but is not limited to, providing official
        government or legal documents.
      </div>
      <div>
        <SectionSubHeading>2.4. Permitted Users</SectionSubHeading>
        By granting any individuals or entities permissions under Builder's
        Account ("Permitted User"), Builder represents and warrants that (a) the
        Permitted User is authorized to act on Builder's behalf, and (b) Builder
        is fully responsible and liable for any action of any Permitted User and
        any other person who uses the Account. If any such Permitted User
        violates the terms of this Agreement, it may affect Builder's ability to
        use the Platform Services.
      </div>
      <div>
        <SectionSubHeading>2.5. Restrictions</SectionSubHeading>
        Builder represents, warrants, and covenants that Builder will not, and
        will not permit any Permitted User or third party, to (a) use the
        Platform Services to provide services to third parties or otherwise
        provide access to the Platform Services to third parties; (b) modify any
        documentation, or create any derivative product thereof; (c) assign,
        sublicense, sell, resell, lease, rent, or otherwise transfer or convey,
        or pledge as security or otherwise encumber ATeams' rights under this
        Section; (d) harvest, collect, gather or assemble information or data
        regarding other Users without their consent; or (e) use the Platform
        Services or any information or data received through or in connection
        with the Platform Services in a manner that (i) may infringe or violate
        the intellectual property or other rights of any individual or entity,
        including without limitation the rights of publicity or privacy; (ii)
        may violate applicable laws or governmental regulations; (iii) is
        unlawful, threatening, abusive, harassing, misleading, false,
        defamatory, libelous, deceptive, fraudulent, invasive of another's
        privacy, tortious, obscene, offensive, profane or racially, ethnically,
        or otherwise discriminatory; (iv) constitutes unauthorized or
        unsolicited advertising, junk or bulk e-mail; (v) impersonates any
        person or entity, including any employee or representative of ATeams;
        (vi) interferes with or attempts to interfere with the proper
        functioning of the Platform Services or uses the Platform Services in
        any way not expressly permitted by this Agreement; or (vii) attempts to
        engage in or engages in, any potentially harmful acts that are directed
        against the Platform Services.
      </div>
      <div>
        <SectionSubHeading>2.6. Investigations</SectionSubHeading>
        Although ATeams does not generally monitor User activity occurring in
        connection with the Platform Services, if ATeams becomes aware of any
        possible violations by any Users of any terms between ATeams and its
        Users, ATeams reserves the right, but has no obligation, to investigate
        such violations. If, as a result of the investigation, ATeams believes
        that criminal activity has occurred, ATeams reserves the right to refer
        the matter to, and to cooperate with, any and all applicable legal
        authorities. ATeams is entitled, except to the extent prohibited by
        applicable law, to disclose any information or materials on or in
        connection with the Platform Services, including Builder Content, in
        ATeams' possession in connection with Builder's use of the Platform
        Services, to (i) comply with applicable laws, legal process or
        governmental request; (ii) enforce the Agreement; (iii) respond to any
        claims that Registration Data, acts, or omissions violate the rights of
        third parties; (iv) respond to requests for customer service; or (v)
        protect the rights, property or personal safety of ATeams, its Users or
        the public, and all enforcement or other government officials, as ATeams
        in its sole discretion believes to be necessary or appropriate.
      </div>
      <div>
        <SectionSubHeading>2.7. Builder Content</SectionSubHeading>
        Builder owns all rights, title and interest in, and Builder hereby
        grants ATeams a fully paid, royalty-free, worldwide, non-exclusive right
        and license to use, distribute, reproduce, modify, adapt, publicly
        perform, and publicly display, the Registration Data and any
        information, data, text, software, and/or other materials provided by or
        on Builder's behalf to ATeams in connection with the Platform Services
        (collectively, "Builder Content") for the purposes of operating and
        improving the Platform Services - and to allow third parties acting on
        ATeams' behalf to do the same. Without limiting the preceding, such
        third parties may include artificial intelligence services, provided
        that any such AI service is required to use the Builder Content in
        accordance with their most protective privacy settings (e.g., won't use
        the Builder Content to train models and the data is retained for the
        shortest period required by the third party provider). Builder also
        agrees that ATeams may process Builder Content with the content of
        others to create and compile aggregated data and/or statistics, and to
        use the aggregated data and statistics in connection with its business
        (including distributions to third parties), provided that such
        aggregated data and statistics will not enable Builder to be identified.
        Builder is solely responsible for Builder Content, including the
        accuracy thereof, and for any legal action that may be instituted by
        other Users or third parties as a result of or in connection with
        Builder Content.
      </div>
      <SectionHeading>3. DEVELOPMENT SERVICES</SectionHeading>
      <div>
        <SectionSubHeading>
          3.1. Performance of Development Services
        </SectionSubHeading>
        Builder will perform the Development Services in accordance with the
        terms of the Agreement, including any applicable Service Order. Builder
        will have exclusive control over the manner and means of performing the
        Development Services, including the choice of place and time, and will
        use Builder's expertise and creative talents in performing the
        Development Services. Unless otherwise set forth in a Service Order,
        Builder will provide, at Builder's own expense, a place of work and all
        equipment, tools, and other materials necessary to complete the
        Development Services.
      </div>
      <div>
        <SectionSubHeading>3.2. Service Orders; Acceptance</SectionSubHeading>
        ATeams and Builder will develop and enter into one or more Service
        Orders incorporating a description of the Development Services. Each
        Service Order will set forth, to the extent applicable, the project
        scope, schedule, any various project activities and tasks to be
        performed by the parties and roles and responsibilities of the parties.
        Each Service Order may further identify and describe, if applicable, the
        specific Work Product that Builder is obligated to furnish to the Client
        thereunder and the acceptance criteria for the Work Product (the
        "Acceptance Criteria").
      </div>
      <div>
        <SectionSubHeading>3.3. Modification</SectionSubHeading>
        ATeams may at any time request a modification to the Development
        Services to be performed pursuant to any particular Service Order by
        written request to Builder specifying the desired modifications,
        including requests for changes in project plans, scope, specifications,
        schedule, designs or requirements. Builder will, within a reasonable
        time following receipt of such request, submit an estimate of the cost
        for such modifications and a revised estimate of the time for
        performance of the Development Services pursuant to the applicable
        Service Order. If accepted in writing by ATeams, such modifications in
        the Service Order will be performed under the terms of this Agreement.
        Modifications in any Service Order will become effective if and only
        when such written change request is executed by authorized
        representatives of both parties.
      </div>
      <div>
        <SectionSubHeading>3.4. Acceptance</SectionSubHeading>
        This Section 3.4 will apply only if the Service Order contains express
        acceptance criteria in the Section of the Service Order entitled
        Acceptance Criteria (the "Acceptance Criteria"). Unless otherwise set
        forth in the applicable Service Order, ATeams will have thirty (30) days
        from the delivery of any Work Product (the "Acceptance Period") to
        assess whether such Work Product substantially conforms to the
        Acceptance Criteria. If ATeams determines, in ATeams' sole discretion,
        that the Work Product does not substantially conform to the Acceptance
        Criteria, ATeams may notify Builder and must provide Builder with a
        written description of all non-conformities to be corrected in
        sufficient detail to enable ATeams to replicate the non-conformities (a
        "Rejection Notice"). Builder will have ten (10) days from receipt of
        such Rejection Notice to modify the Work Product to remedy the
        deficiencies identified by ATeams and to re-submit the Work Product to
        ATeams for further review and/or acceptance testing. Such modification
        and re-submission shall be at no additional cost to ATeams. ATeams will
        have fifteen (15) days, or such other period as may be specified in the
        applicable Statement of Work, within which to review the Work Product
        and/or perform additional acceptance testing and to advise Builder
        whether the Work Product, as modified, is acceptable (the "Additional
        Acceptance Testing"). If the Work Product remains unacceptable despite
        Builder's attempts to modify such Work Product, ATeams may, at its
        option, either: (a) reject, in whole or in part, the unacceptable Work
        Product, and any Work Product previously accepted, if the use of such
        previously accepted Work Product is dependent on the rejected Work
        Product, and return such rejected part or parts to Builder, in which
        case (i) no Fees will be due to Builder in connection with such rejected
        Work Product or (ii) if such Fees have been paid in advance, then
        Builder, within fifteen (15) days after receipt of such returned Work
        Product, will refund to ATeams (without reduction, abatement or set-off)
        all payments made to it by ATeams for such returned Work Product; or (b)
        again, engage in the Additional Acceptance Testing. The process
        described in this Section 3.4 will be repeated until ATeams either
        returns the rejected Work Product to Builder for refund or accepts the
        Work Product.
      </div>
      <div>
        <SectionSubHeading>
          3.5. Compliance with ATeam and Client Policies
        </SectionSubHeading>
        Builder agrees that it will comply with all ATeam and Client policies
        made available to Builder by either ATeams or Client, including any
        policies regarding the handling of data and source code, the use and
        incorporation of open source software, and any security policies.
      </div>
      <SectionHeading>4. NO SUBCONTRACTING</SectionHeading>
      Builder will not subcontract or otherwise delegate any of Builder's
      obligations under this Agreement without ATeams' express prior written
      consent on a case-by-case basis. Upon receipt of such consent, before
      allowing any subcontractor to begin performing services, Builder will
      enter into a binding written agreement with such subcontractor that
      protects ATeams' rights and interests to at least the same degree as this
      Agreement. Builder will be responsible for the direction and coordination
      of the services of each subcontractor. ATeams will have no obligation to
      pay any subcontractor.
      <SectionHeading>5. INDEPENDENT CONTRACTOR RELATIONSHIP</SectionHeading>
      Builder's relation to ATeams under this Agreement is that of an
      independent contractor. Nothing in this Agreement is intended or should be
      construed to create a partnership, joint venture, or employer-employee
      relationship between ATeams and Builder. Builder will take no position
      with respect to or on any tax return or application for benefits, or in
      any proceeding directly or indirectly involving ATeams, that is
      inconsistent with Builder being an independent contractor (and not an
      employee) of ATeams. Builder is not the agent of ATeams and is not
      authorized, and must not represent to any third party that Builder is
      authorized, to make any commitment or otherwise act on behalf of ATeams.
      <SectionHeading>6. COMPENSATION</SectionHeading>
      <div>
        <SectionSubHeading>6.1. Fees</SectionSubHeading>
        Builder will provide Development Services for the fees specified in a
        Service Order. Subject to the terms and conditions of this Agreement,
        ATeams will pay Builder the fees specified in a Service Order ("Builder
        Fees") as Builder's sole and complete compensation for all Development
        Services performed by Builder under this Agreement. No other fees will
        be owed by ATeams under this Agreement.
      </div>
      <div>
        <SectionSubHeading>6.2. Expenses</SectionSubHeading>
        ATeams will reimburse Builder for any reasonable out-of-pocket expenses
        that are approved in advance by ATeams in writing and incurred by
        Builder or any of its employees or agents in performing the Development
        Services ("Expenses") on the condition that Builder complies with
        ATeams' and the Client's policy for the submission and verification of
        such Expenses. Builder is responsible for obtaining the then-current
        version of such policy before submitting any request for reimbursement.
      </div>
      <div>
        <SectionSubHeading>6.3. Invoicing and Payment</SectionSubHeading>
        Unless otherwise set forth in a Service Order, Builder will submit
        invoices to ATeams on the 15th and last day of each calendar month for
        Development Services performed and Expenses incurred since the last
        invoice date. Builder will report hours worked for each individual and
        any other detail required by the Client. ATeams will pay undisputed
        amounts invoiced within thirty (30) days of receipt of invoice.
      </div>
      <div>
        <SectionSubHeading>6.4. Taxes</SectionSubHeading>
        Builder is solely responsible for filing all tax returns and submitting
        all payments as required by any federal, state, local, or foreign tax
        authority arising from the payment of Builder Fees under this Agreement,
        and agrees to do so in a timely manner. ATeams will provide ATeams with
        Form 1099-MISC for Builder, and ATeams will file Form 1099-MISC with the
        Internal Revenue Service as required by law.
      </div>
      <SectionHeading>7. CONFIDENTIALITY</SectionHeading>
      <div>
        <SectionSubHeading>7.1. Use and Disclosure</SectionSubHeading>
        ATeams and Builder each agree as follows: (a) to use Confidential
        Information disclosed by the other party only for the purposes expressly
        permitted herein; (b) that such party will not reproduce Confidential
        Information disclosed by the other party, and will hold in confidence
        and protect such Confidential Information from dissemination to, and use
        by, any third party; (c) that neither party will create any derivative
        work from Confidential Information disclosed to such party by the other
        party; (d) it will maintain the confidentiality of all Confidential
        Information of the other party in its possession or control using no
        less than a reasonable standard of care; (e) to restrict access to the
        Confidential Information disclosed by the other party to such of its
        personnel, agents, and/or consultants, who have a need to have access
        and who have been advised of, and have agreed in writing to treat such
        information in accordance with terms substantially similar to, and at
        least as protective as, those contained in this Agreement; and (f) to
        the extent practicable, return or destroy all Confidential Information
        disclosed by the other party that is in its possession upon termination
        or expiration of this Agreement. Both parties agree that all items of
        Confidential Information are proprietary to the disclosing party, and as
        between the parties, will remain the sole property of the disclosing
        party. For the avoidance of doubt: Builder acknowledges that: (i) Client
        or ATeams may share Confidential Information of Client with Builder;
        (ii) ATeams may share Builder Confidential information with Client, in
        each case solely in connection with the provision of the Services and
        (iii) for the purpose of this Section 7, Client Confidential Information
        is deemed ATeams Confidential Information and Builder will treat all
        Client Confidential Information as ATeams Confidential Information.
      </div>
      <div>
        <SectionSubHeading>7.2. Confidentiality Exceptions</SectionSubHeading>
        Notwithstanding the foregoing, the provisions of Section 7.1, will not
        apply to information that (a) is publicly available or in the public
        domain at the time such information is disclosed; (b) is or becomes
        publicly available or enters the public domain through no fault of the
        recipient; (c) is rightfully communicated to the recipient by persons
        not bound by confidentiality obligations with respect thereto; (d) is
        already rightfully in the recipient's possession free of any
        confidentiality obligations with respect thereto at the time of
        disclosure; (e) is independently developed by the recipient without use
        of or reference to the other party's Confidential Information; or (f) is
        approved for release or disclosure by the disclosing party without
        restriction. Notwithstanding the foregoing, each party may disclose
        Confidential Information to the limited extent required (i) to comply
        with the order of a court or other governmental body, or as otherwise
        necessary to comply with applicable law, provided that the party making
        the disclosure pursuant to the order shall first have given written
        notice to the other party (to the extent legally permitted) and made a
        reasonable effort to obtain a protective order; or (ii) to establish a
        party's rights under this Agreement, including to make such court
        filings as it may be required to do.
      </div>
      <div>
        <SectionSubHeading>7.3. Defend Trade Secrets Act</SectionSubHeading>
        Notwithstanding the foregoing, pursuant to 18 U.S.C. Section 1833(b),
        Builder shall not be held criminally or civilly liable under any Federal
        or state trade secret law for the disclosure of a trade secret that: (a)
        is made in confidence to a Federal, state or local government official,
        either directly or indirectly, or to an attorney, and solely for the
        purpose of reporting or investigating a suspected violation of law; or
        (b) is made in a complaint or other document filed in a lawsuit or other
        proceeding, if such filing is made under seal. Notwithstanding the
        foregoing or anything to the contrary in this Agreement or any other
        agreement between the ATeams and Builder, nothing in this Agreement
        shall limit Builder's right to report possible violations of law or
        regulation with any federal, state, or local government agency or to
        discuss the terms and conditions of Builder's employment by ATeams to
        the extent that such disclosure is protected under applicable provisions
        of law or regulation, including but not limited to "whistleblower"
        statutes or other similar provisions that protect such disclosure.
      </div>
      <SectionHeading>8. WORK PRODUCT</SectionHeading>
      <div>
        <SectionSubHeading>8.1. Client Materials</SectionSubHeading>
        Subject to the terms of this Agreement, ATeams grants Builder a limited,
        non-exclusive, revocable (at any time, at ATeams sole discretion) right
        to use any materials or information provided by ATeams related to Client
        or by the Client (collectively, the "Client Materials") as necessary
        solely for the performance of the Development Services under this
        Agreement. As between ATeams and Builder, ATeams reserves all other
        rights and interest, including, without limitation, all Intellectual
        Property Rights, in and to the Client Materials. Upon completion or
        termination of this Agreement, or upon ATeams written request, Builder
        will immediately return, or at ATeams' option, destroy all Client
        Materials and copies thereof contained in or on Builder's premises,
        systems, or any other equipment or location otherwise under Builder's
        control.
      </div>
      <div>
        <SectionSubHeading>8.2. Disclosure</SectionSubHeading>
        <div>
          <SectionSubHeading>
            8.2.1. Disclosure of Work Product
          </SectionSubHeading>
          Builder will deliver all Work Product to the Client (or any person
          designated by ATeams in writing) in the form required by ATeams.
        </div>
        <div>
          <SectionSubHeading>
            8.2.2. Background and Third-Party Technology
          </SectionSubHeading>
          Intellectual Property developed, acquired, or otherwise obtained by
          Builder prior to this Agreement (collectively, "Background
          Technology") or licensed or obtained by Builder from third parties
          (collectively, "Third-Party Technology") or licensed or obtained by
          Builder from ATeams ("ATeams Technology") may not be used by Builder
          in the performance of the Development Services unless approved in
          advance and in writing by ATeams. In no event will Builder incorporate
          into the Work Product any software code licensed under the GNU, GPL or
          LPGL or any other open source license. without the written approval of
          ATeams or Client. Builder represents and warrants that Builder has an
          unqualified right to license to ATeams all Background Technology and
          Third-Party Technology as provided herein.
        </div>
      </div>
      <div>
        <SectionSubHeading>
          8.3. Ownership and Assignment of Work Product
        </SectionSubHeading>
        Builder agrees that all Work Product will be the sole and exclusive
        property of ATeams. Elements in the Work Product that are protected by
        copyright are "works made for hire" for which ATeams is the "author" (as
        such first quoted term is defined by and such second quoted term given
        meaning by the United States Copyright Act of 1976, as amended). ATeams
        will exclusively own the copyright in all such works upon their
        creation. To the extent that any aspect of such Work Product is found as
        a matter of law not to be a "work made for hire" as contemplated above,
        except for Builder's Intellectual Property Rights in the Background
        Technology, Builder hereby irrevocably and unconditionally assigns to
        ATeams all right, title, and interest worldwide in and to the Work
        Product and all Intellectual Property Rights therein. Builder
        understands and agrees that Builder has no right to use the Work Product
        except as necessary to perform the Development Services for ATeams.
      </div>
      <div>
        <SectionSubHeading>
          8.4. Assignment and Waiver of Other Rights
        </SectionSubHeading>
        If any Intellectual Property Rights, including moral rights, in the Work
        Product (other than Background Technology or Third Party Technology
        approved for use as specified in Section 8.2.2) cannot as a matter of
        law be assigned by Builder to ATeams as provided in Section 8.3, then
        (a) Builder unconditionally and irrevocably waives the enforcement of
        such rights and all claims and causes of action of any kind against
        ATeams with respect to such rights and (b) to the extent Builder cannot
        (as a matter of law) make such waiver, Builder unconditionally grants to
        ATeams an exclusive, perpetual, irrevocable, worldwide, fully-paid
        license, with the right to sublicense through multiple levels of
        sublicensees, under any and all such rights (i) to reproduce, create
        derivative works of, distribute, publicly perform, publicly display,
        digitally transmit, and otherwise use and exploit the Work Product in
        any medium or format, whether now known or hereafter discovered, (ii) to
        use, make, have made, sell, offer to sell, import, and otherwise exploit
        any product or service based on, embodying, incorporating, or derived
        from the Work Product, and (iii) to exercise any and all other present
        or future rights in the Work Product.
      </div>
      <div>
        <SectionSubHeading>
          8.5. License of Background Technology
        </SectionSubHeading>
        Builder unconditionally grants to ATeams a non-exclusive, perpetual,
        irrevocable, worldwide, fully-paid, royalty-free, right and license,
        with the right to sublicense through multiple levels of sublicensees,
        any and all Background Technology (including all related Intellectual
        Property Rights) used or incorporated in any Work Product or otherwise
        used by Builder in performance of the Development Services, (a) to
        reproduce, create derivative works of, distribute, publicly perform,
        publicly display, digitally transmit, and otherwise use the Work Product
        in any medium or format, whether now known or hereafter discovered, (b)
        to use, make, have made, sell, offer to sell, import, and otherwise
        exploit any product or service based on, embodying, incorporating, or
        derived from the Work Product and (c) to exercise any and all other
        present or future rights in the Work Product and (d) for the avoidance
        of doubt, to all Client to do the same, including the right to
        sublicense through multiple levels of sublicensees.
      </div>
      <div>
        <SectionSubHeading>
          8.6. Assignment of Rights to Third-Party Technology
        </SectionSubHeading>
        Builder hereby assigns to ATeams all of Builder's licenses and other
        rights to all Third-Party Technology incorporated into the Work Product.
        If such rights cannot be validly assigned to ATeams without the consent
        of a third party, Builder will use best efforts to obtain such consent
        (at Builder's expense) and will indemnify and hold harmless ATeams and
        its affiliates, employees, and agents from and against all liabilities,
        losses, damages, costs, and expenses (including attorneys' fees) arising
        from Builder's failure to obtain such consent.
      </div>
      <SectionHeading>9. FURTHER ASSURANCES</SectionHeading>
      Builder will, at ATeams' request, (a) cooperate with and assist ATeams,
      both during and after the term of this Agreement, in perfecting,
      maintaining, protecting, and enforcing ATeams' rights in the Work Product,
      and (b) execute and deliver to ATeams (or at ATeams request, to any
      Client) any documents deemed necessary or appropriate by ATeams in its
      discretion to perfect, maintain, protect, or enforce ATeams' rights in the
      Work Product or otherwise carry out the purpose of this Agreement. ATeams
      will reimburse Builder for any reasonable out-of-pocket expenses actually
      incurred by Builder in fulfilling Builder's obligations under this
      Section.
      <SectionHeading>
        10. BUILDER REPRESENTATIONS AND WARRANTIES
      </SectionHeading>
      Builder represents, warrants, and covenants that: (a) Builder will not, in
      the course of performing the Development Services, infringe or
      misappropriate, and neither the Work Product nor any element thereof will
      infringe or misappropriate, any Intellectual Property Right of any other
      person; (b) Builder will perform the Development Services in a
      professional and workmanlike manner; (c) the Development Services and Work
      Product will conform to the descriptions set forth in each applicable
      Service Order; (d) neither the Work Product nor any element thereof will
      be subject to any restriction, mortgage, lien, claim, pledge, security
      interest, or encumbrance when delivered by Builder to Client; (e) Builder
      will not grant, directly or indirectly, any right or interest in the Work
      Product (other than any Background Technology it may contain) to any other
      person; (f) Builder has full right, power, and authority to enter into and
      perform this Agreement without the consent of any third party, including
      the right to grant all licenses granted by Builder in this Agreement; (g)
      All individuals who contribute to or participate in the conception,
      creation, or development of the Work Product will have unconditionally and
      irrevocably assigned all of their right, title, and interest in and to the
      Work Product (and all Intellectual Property Rights thereto) to Builder (or
      directly to ATeams) before being allowed to begin performing the
      Development Services; and (h) Builder will refrain from any unethical
      conduct, will maintain high standards of professionalism, and will comply
      with all laws, regulations, and ordinances applicable to Builder's
      performance of the Development Services and Builder's other obligations
      under this Agreement, including export control laws, and has obtained (or
      before performing the Development Services will obtain) all governmental
      permits and licenses required for Builder to perform the Development
      Services and Builder's other obligations under this Agreement.
      <SectionHeading>11. Indemnification</SectionHeading>
      <div>
        <SectionSubHeading>11.1. Mutual Indemnification</SectionSubHeading>
        Each party will defend, at its expense, any claim or suit brought
        against the other party, its parents, subsidiaries, affiliates,
        officers, employees, agents, partners suppliers and licensors (each a
        "Indemnified Party" and collectively, the "Indemnified Parties") and
        will indemnify and hold the Indemnified Parties harmless with respect to
        any settlement the indemnifying party makes or approves, or any damages
        finally awarded in such claim or suit, insofar as such claim or suit is
        based on a claim by any third party alleging personal bodily injury or
        wrongful death or damage to real or tangible personal property resulting
        from the indemnifying party's gross negligence or willful misconduct.
      </div>
      <div>
        <SectionSubHeading>
          11.2. Infringement Indemnification
        </SectionSubHeading>
        Builder will defend, at its expense, any claim or suit brought against
        ATeams, its parents, subsidiaries, affiliates, officers, employees,
        agents, partners suppliers and licensors (each a "ATeams Party" and
        collectively, the "ATeams Parties") and will indemnify and hold ATeams
        Parties harmless with respect to any settlement Builder makes or
        approves, or any damages finally awarded in such claim or suit, insofar
        as such claim or suit is based on a claim by any third party alleging
        that use of the Work Product, as permitted hereunder, infringes or
        misappropriates the Intellectual Property Rights of a third party
        ("Infringement Claim"). Builder will have no liability or obligation
        with respect to any Infringement Claim to the extent such Infringement
        Claim is caused by: (a) Builders compliance with designs, guidelines,
        plans or specifications provided by ATeams; (b) modification of the Work
        Product at ATeams direction by any party other than Builder or Builder
        personnel; (c) ATeams' Confidential Information; or (d) the unauthorized
        combination, operation or use of the Work Product by ATeams or on behalf
        of ATeams with other applications, portions of applications, product(s)
        or services, where the Work Product would not by itself be infringing.
        Should ATeams' use of any Work Product furnished by Builder be enjoined
        by any court, Builder shall promptly obtain, at no expense to ATeams,
        the right to continue to use the items so enjoined without restriction
        or, at no expense to ATeams, or promptly provide ATeams with
        non-infringing means to use the items so enjoined. This Section states
        Builder's sole and exclusive liability and obligation, and ATeams'
        exclusive remedy, for any claim of any nature related to infringement or
        misappropriation of Intellectual Property.
      </div>
      <div>
        <SectionSubHeading>11.3. Indemnification Procedure</SectionSubHeading>
        The indemnified party will (a) provide the indemnifying party with
        prompt written notice of any claim for which indemnification is sought,
        provided, however, that the failure to give timely notice will not
        relieve the indemnifying party of its obligations except to the extent
        that such delay impairs the ability of the indemnifying party to defend
        or settle the claim; (b) cooperate with the indemnifying party (at the
        indemnifying party's expense) and provide reasonable assistance and
        information; and (c) permit the indemnifying party to control and direct
        the defense or settlement of any such claim, provided that the
        indemnifying party will not settle any claim which settlement terms
        requires the indemnified party to admit liability without the
        indemnifying party's prior written consent. The indemnified party may
        participate in the defense and settlement of such claim at the
        indemnified party's sole expense.
      </div>
      <SectionHeading>12. LIMITATION OF LIABILITY</SectionHeading>
      EXCEPT WITH REGARD TO A PARTY'S INDEMNIFICATION OBLIGATIONS AND FOR CLAIMS
      ARISING OUT OF BREACHES OF SECTIONS 5, 7, 14 OR 15, IN NO EVENT WILL
      EITHER PARTY BE LIABLE TO THE OTHER FOR ANY INDIRECT, SPECIAL,
      CONSEQUENTIAL, PUNITIVE OR INCIDENTAL DAMAGES, WHETHER BASED ON BREACH OF
      CONTRACT, TORT (INCLUDING NEGLIGENCE), OR ANY OTHER LEGAL THEORY, EVEN IF
      ADVISED OF THE POSSIBILITY OF SUCH DAMAGES. IN NO EVENT WILL ATeams BE
      LIABLE TO BUILDER FOR ANY LOST REVENUE OR LOST PROFITS OTHER THAN ATeams
      RESPONSIBILITY TO PAY THE FEES CONTEMPLATED BY SECTION 6.
      <SectionHeading>13. RECORDS</SectionHeading>
      Builder will create and maintain records to document Builder's compliance
      with the obligations under this Agreement and provide copies of such
      records to ATeams upon request.
      <SectionHeading>14. NON-SOLICIT</SectionHeading>
      During the Term and for twelve (12) months thereafter, Builder will not
      directly or indirectly seek to employ or engage any other user of the
      Platform or employee or contractor of any Client or ATeams.
      <SectionHeading>15. NO CIRCUMVENTION</SectionHeading>
      During the term of this Agreement and for twelve (12) months thereafter
      (the "Non-Circumvention Period"), Builder will not: (a) directly solicit
      the employment of any Client or (b) use any method other than the Platform
      to: (i) seek any contractor, consulting or similar work from any Client or
      any ATeams client (e.g., any entity seeking to match with a builder the
      Platform Services) or (ii) seek any payment or other method of
      compensation from any Client. If Builder commences or continues working
      with any Client during the Non-Circumvention Period, Builder will pay
      ATeams the greater of: (a) twenty thousand dollars ($20,000) or (b) (i)
      the amount that is equal to three times (3x) the anticipated monthly
      amount Client will pay Builder, plus (ii) ten percent (10%) of any
      one-time signing bonus or similar additional compensation (the "Network
      Fee"). For the avoidance of doubt, if: (x) Client paid to ATeams the
      applicable Network Fee, the obligation for Builder to pay such Network Fee
      will be waived and (y) if Client and Builder worked together before being
      introduced or matched through the Platform Services then the
      Non-Circumvention provisions of this Section 15 do not apply with respect
      to such Client and Builder.
      <SectionHeading>16. GENERAL</SectionHeading>
      <div>
        <SectionSubHeading>16.1. Assignment</SectionSubHeading>
        Builder may not assign or transfer this Agreement, in whole or in part,
        without ATeams' express prior written consent. Any attempt to assign
        this Agreement, without such consent, will be void. Subject to the
        foregoing, this Agreement will bind and benefit the parties and their
        respective successors and assigns.
      </div>
      <div>
        <SectionSubHeading>16.2. No Election of Remedies</SectionSubHeading>
        Except as expressly set forth in this Agreement, the exercise by ATeams
        of any of its remedies under this Agreement will not be deemed an
        election of remedies and will be without prejudice to its other remedies
        under this Agreement or available at law or in equity or otherwise.
      </div>
      <div>
        <SectionSubHeading>16.3. Governing Law; Jurisdiction</SectionSubHeading>
        This Agreement will be governed by and construed in accordance with the
        laws of the State of New York, without regard to its conflicts of law
        provisions. The parties agree that any and all claims arising under this
        Agreement will be resolved through arbitration using the American
        Arbitration Association and its Commercial Arbitration Rules. Any
        arbitration will be conducted in New York County, New York. The
        arbitrator may grant injunctive or other relief. The decision of the
        arbitrator will be final, conclusive and binding on the parties.
        Judgment may be entered on the arbitrator's decision in any court of
        competent jurisdiction.
      </div>
      <div>
        <SectionSubHeading>16.4. Severability</SectionSubHeading>
        If any provision of this Agreement is held invalid or unenforceable by a
        court of competent jurisdiction, the remaining provisions of this
        Agreement will remain in full force and effect, and the provision
        affected will be construed so as to be enforceable to the maximum extent
        permissible by law.
      </div>
      <div>
        <SectionSubHeading>16.5. Notices</SectionSubHeading>
        All notices required or permitted under this Agreement will be in
        writing and delivered by confirmed electronic transmission, by courier
        or overnight delivery service, or by certified mail, and in each
        instance will be deemed given upon receipt. All communications will be
        sent to the addresses set forth in the applicable Service Order or to
        such other address as may be specified by either party to the other in
        accordance with this Section.
      </div>
      <div>
        <SectionSubHeading>16.6. Waiver</SectionSubHeading>
        The waiver by either party of any default or breach of this Agreement
        will not constitute a waiver of any other or subsequent default or
        breach. Except as expressly set forth in this Agreement, no term or
        condition of this Agreement will be deemed waived unless such waiver is
        in a writing signed by the party against whom the waiver is sought to be
        enforced.
      </div>
      <div>
        <SectionSubHeading>16.7. Entire Agreement</SectionSubHeading>
        This Agreement, together with all exhibits hereto and all Service
        Orders, constitutes the complete and exclusive agreement between the
        parties with respect to its subject matter and supersedes all prior or
        contemporaneous agreements, communications, and understandings, both
        written and oral, with respect to such subject matter. This Agreement
        may only be modified, or any rights under it waived, by a written
        document executed by both parties.
      </div>
      <div>
        <SectionSubHeading>16.8. Counterparts</SectionSubHeading>
        This Agreement may be executed in counterparts, each of which will be
        deemed an original, but all of which together will constitute one and
        the same instrument.
      </div>
    </div>
  );
}
